/* ================================================================
   AUTOWELT — main.js v2
   Buscador por vehículo · garaje · búsqueda predictiva · carrito AJAX
   ================================================================ */
(function () {
  'use strict';

  var CFG = (window.AW && window.AW.cfg) || {};
  var R = CFG.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var STORE_KEY = 'aw_vehicle_v2';

  /* ── Utilidades ─────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slugify(s) {
    return String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function norm(s) {
    return String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/[^a-z0-9.\- ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function debounce(fn, ms) {
    var t; return function () { var a = arguments, me = this; clearTimeout(t); t = setTimeout(function () { fn.apply(me, a); }, ms); };
  }
  function storeGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function storeSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function waUrl(text) { return 'https://wa.me/' + (CFG.whatsapp || '') + '?text=' + encodeURIComponent(text); }

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || CFG.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function delim(n, prec, th, dec) {
      th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount_no_decimals_with_comma_separator') {
      case 'amount': v = delim(cents, 2); break;
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = delim(cents, 0, ' '); break;
      default: v = delim(cents, 0, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ── Toast ──────────────────────────────────────────────── */
  var toastT;
  function toast(title, msg, type) {
    var el = $('#aw-toast'); if (!el) return;
    $('#aw-toast-title').textContent = title || '';
    $('#aw-toast-msg').textContent = msg || '';
    el.classList.toggle('is-warn', type === 'warn');
    el.classList.add('is-visible');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }
  window.awToast = toast;
  window.awHideToast = function () { var el = $('#aw-toast'); if (el) el.classList.remove('is-visible'); };

  /* ── Paneles (carrito, menú, vehículo, filtros) ─────────── */
  var openPanel = null, lastFocus = null;
  function panelEl(name) { return $('[data-aw-panel="' + name + '"]'); }
  function open(name) {
    var p = panelEl(name); if (!p) return false;
    if (openPanel && openPanel !== p) close();
    lastFocus = document.activeElement;
    p.hidden = false;
    requestAnimationFrame(function () { p.classList.add('is-open'); });
    var ov = $('[data-aw-overlay]'); if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
    document.documentElement.classList.add('aw-lock');
    openPanel = p;
    var f = p.querySelector('select, input, button, a[href]'); if (f) setTimeout(function () { f.focus(); }, 60);
    if (name === 'cart') refreshCart();
    return true;
  }
  function close() {
    if (!openPanel) return;
    var p = openPanel; openPanel = null;
    p.classList.remove('is-open');
    var ov = $('[data-aw-overlay]'); if (ov) ov.classList.remove('is-open');
    document.documentElement.classList.remove('aw-lock');
    setTimeout(function () {
      if (!p.classList.contains('is-open')) {
        // los filtros de escritorio siguen visibles; solo se ocultan en móvil vía CSS
        if (p.getAttribute('data-aw-panel') !== 'filters') p.hidden = true;
        if (ov && !openPanel) ov.hidden = true;
      }
    }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-aw-open]');
    if (o) {
      if (open(o.getAttribute('data-aw-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-aw-close]') || e.target.matches('[data-aw-overlay]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); hideSuggest(); } });

  /* ── Datos de vehículos ─────────────────────────────────── */
  var VD = {};
  var vdEl = $('#aw-vehicle-data'), VD_TAGS = !!(vdEl && vdEl.getAttribute('data-tags'));
  try { if (vdEl) VD = JSON.parse(vdEl.textContent); } catch (e) { VD = {}; }

  function brandName(b) { return (VD[b] && VD[b].n) || b; }
  function modelInfo(b, m) {
    var r = VD[b] && VD[b].m && VD[b].m[m];
    return r ? { name: r[0], from: r[1], to: r[2], n: r[3], q: r[4] || r[0], al: r[5] || [], g: r[6] || [], ys: r[7] || null } : null;
  }
  // generación de un año: la más nueva que contiene ese año (ej. Accent 2016 → Accent RB)
  function genFor(b, m, y) {
    var mi = modelInfo(b, m); y = +y;
    if (!mi || !y || !mi.g.length) return null;
    var best = null;
    mi.g.forEach(function (g) {
      var hasta = g[2] || 9999;
      if (g[1] <= y && y <= hasta && (!best || g[1] > best[1])) best = g;
    });
    return best;
  }
  function genLabel(g) { return g[0] + ' (' + g[1] + '-' + (g[2] || '…') + ')'; }
  function vehicleTag(v) {
    if (!v || !v.b) return '';
    var t = 'fit-' + v.b;
    if (v.m) t += '-' + v.m;
    if (v.m && v.y) t += '-' + v.y;
    return t;
  }
  function vehicleName(v, short) {
    if (!v || !v.b) return '';
    var mi = v.m ? modelInfo(v.b, v.m) : null;
    var s = short ? '' : brandName(v.b) + ' ';
    var gy = (mi && v.y) ? genFor(v.b, v.m, v.y) : null;
    s += gy ? gy[0] : (mi ? mi.name : (v.m || ''));
    if (v.y) s += ' ' + v.y;
    return s.trim() || brandName(v.b);
  }
  function parseTag(tag) {
    tag = String(tag || '').replace(/^fit-/, '');
    if (!tag) return null;
    var parts = tag.split('-'), b = parts.shift(), y = '';
    if (parts.length && /^\d{4}$/.test(parts[parts.length - 1]) && parts.length > 1) y = parts.pop();
    return { b: b, m: parts.join('-'), y: y };
  }
  // "auto": usa etiquetas solo si el snippet de vehículos fue generado por el script (data-tags="1")
  function useTags() { return CFG.mode === 'tags' || (CFG.mode === 'auto' && VD_TAGS); }

  // Palabra de pieza → subcategoría (etiqueta sub- que crea el script). El orden importa: lo más específico primero.
  var SUBCATS = [
    [/\bpastillas?\b/, 'pastillas-de-freno', 'Pastillas de freno'],
    [/\bdiscos? (de )?freno\b|\bdisco\b(?!.*embrague)/, 'discos-de-freno', 'Discos de freno'],
    [/\bkit (de )?embrague\b|\bdisco (de )?embrague\b|\bprensa\b/, 'kits-de-embrague', 'Kits de embrague'],
    [/\bbomba (de )?agua\b/, 'bombas-de-agua', 'Bombas de agua'],
    [/\bbomba (de )?aceite\b/, 'bombas-de-aceite', 'Bombas de aceite'],
    [/\bfiltro (de )?aceite\b/, 'filtros-de-aceite', 'Filtros de aceite'],
    [/\bfiltro (de )?aire\b/, 'filtros-de-aire', 'Filtros de aire'],
    [/\bfiltro (de )?(polen|cabina|habitaculo)\b/, 'filtros-de-polen', 'Filtros de polen'],
    [/\bfiltro (de )?(combustible|bencina|petroleo)\b/, 'filtros-de-combustible', 'Filtros de combustible'],
    [/\bamortiguador/, 'amortiguadores', 'Amortiguadores'],
    [/\bbieleta/, 'bieletas', 'Bieletas'],
    [/\b(extremo|terminal)/, 'terminales-de-direccion', 'Terminales de dirección'],
    [/\baxial/, 'axiales', 'Axiales'],
    [/\bbandeja/, 'bandejas-de-suspension', 'Bandejas de suspensión'],
    [/\brotula/, 'rotulas', 'Rótulas'],
    [/\bcazoleta/, 'cazoletas', 'Cazoletas'],
    [/\bmaza/, 'mazas-de-rueda', 'Mazas de rueda'],
    [/\bhomocinetica/, 'homocineticas', 'Homocinéticas'],
    [/\btermostato/, 'termostatos', 'Termostatos'],
    [/\bradiador/, 'radiadores', 'Radiadores'],
    [/\belectroventilador|\bventilador/, 'electroventiladores', 'Electroventiladores'],
    [/\bmanguera/, 'mangueras', 'Mangueras'],
    [/\bempaquetadura|\bjunta/, 'empaquetaduras-y-juntas', 'Empaquetaduras y juntas'],
    [/\breten/, 'retenes', 'Retenes'],
    [/\b(correa|kit|cadena) (de )?distribucion/, 'distribucion', 'Distribución'],
    [/\btensor|\bpolea/, 'tensores-poleas-y-guias', 'Tensores, poleas y guías'],
    [/\bbujia/, 'bujias', 'Bujías'],
    [/\bbobina/, 'bobinas', 'Bobinas'],
    [/\bsensor/, 'sensores', 'Sensores'],
    [/\bsoporte (de )?motor/, 'soportes-de-motor', 'Soportes de motor'],
    [/\b(farol|foco|neblinero)/, 'iluminacion', 'Iluminación'],
    [/\bespejo/, 'espejos', 'Espejos']
  ];
  function subFor(text) {
    var t = ' ' + norm(text) + ' ';
    for (var i = 0; i < SUBCATS.length; i++) if (SUBCATS[i][0].test(t)) return { slug: SUBCATS[i][1], name: SUBCATS[i][2] };
    return null;
  }
  function vehicleUrl(v, scope, sub) {
    var mz = v && v.m ? modelInfo(v.b, v.m) : null;
    if (mz && mz.n && v.y && mz.ys && mz.ys.indexOf(+v.y) === -1) {
      v = { b: v.b, m: v.m, y: '' };   // ese año no tiene productos: mostrar todos los del modelo
    }
    if (mz && !mz.n) {
      // sin productos publicados: búsqueda por texto (si no hay nada, la página ofrece WhatsApp)
      return (R.search || '/search') + '?type=product&q=' + encodeURIComponent((mz.name + ' ' + (v.y || '')).trim());
    }
    if (!useTags()) {
      var mi = v.m ? modelInfo(v.b, v.m) : null;
      var q = mi ? mi.q : brandName(v.b);
      return (R.search || '/search') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '&aw_v=' + encodeURIComponent(vehicleTag(v));
    }
    var base = (scope || R.all || '/collections/all').replace(/\/$/, '');
    return base + '/' + vehicleTag(v) + (sub ? '+sub-' + sub.slug : '');
  }
  function fallbackSearchUrl(tag) {
    var v = parseTag(tag); if (!v) return R.search;
    var mi = v.m ? modelInfo(v.b, v.m) : null;
    var q = mi ? mi.q : (v.m || '').replace(/-/g, ' ');
    return (R.search || '/search') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '&aw_v=' + encodeURIComponent(tag) + '&aw_fb=1';
  }

  /* ── Garaje: "Mi vehículo" ──────────────────────────────── */
  function getGarage() { return CFG.garage ? storeGet(STORE_KEY) : null; }
  function setGarage(v) { if (CFG.garage) { storeSet(STORE_KEY, v); paintGarage(); } }

  function fits(fitStr, v) {
    if (!v || !v.b || !fitStr) return null;
    var list = ' ' + fitStr + ' ';
    var tag = vehicleTag(v);
    return list.indexOf(' ' + tag + ' ') !== -1;
  }

  function paintGarage() {
    var v = getGarage();
    var name = vehicleName(v), short = vehicleName(v, true);
    $$('[data-aw-garage-label]').forEach(function (el) { el.textContent = v ? short : (el.closest('.aw-mnav') ? 'Elegir mi vehículo' : 'Mi vehículo'); });
    $$('[data-aw-garage-name]').forEach(function (el) { el.textContent = name; });
    $$('[data-aw-garage-short]').forEach(function (el) { el.textContent = short; });
    $$('[data-aw-garage-link]').forEach(function (el) { if (v) el.href = vehicleUrl(v); });
    $$('.aw-hact--garage').forEach(function (el) { el.classList.toggle('has-vehicle', !!v); });

    var bar = $('[data-aw-garagebar]');
    if (bar) {
      // no repetir la barra en la página de ese mismo vehículo
      var same = v && CFG.currentVehicleTag && CFG.currentVehicleTag === vehicleTag(v);
      bar.hidden = !v || same;
    }

    // Tarjetas: "Calza con tu …"
    $$('[data-aw-card]').forEach(function (card) {
      var b = card.querySelector('[data-aw-fit-badge]'); if (!b) return;
      b.hidden = !(v && v.m && fits(card.getAttribute('data-fit'), v));
    });

    // Ficha de producto
    var pdp = $('[data-aw-pdp]');
    if (pdp) {
      var fc = $('[data-aw-fitcheck]', pdp);
      if (fc) {
        if (fc.hasAttribute('data-nofit')) { fc.hidden = true; }
        else {
          var state = 'none';
          if (v && v.m) state = fits(pdp.getAttribute('data-fit'), v) ? 'ok' : 'no';
          $$('[data-state]', fc).forEach(function (s) { s.hidden = s.getAttribute('data-state') !== state; });
          fc.setAttribute('data-current', state);
        }
      }
      var waLink = $('[data-aw-wa-product]', pdp);
      if (waLink) {
        var msg = waLink.getAttribute('data-base') || '';
        if (v) msg += ' — Mi vehículo: ' + name;
        waLink.href = waUrl(msg);
      }
      // resaltar fila de la tabla de compatibilidad
      if (v && v.m) $$('[data-fit-row]').forEach(function (tr) {
        tr.classList.toggle('is-mine', tr.getAttribute('data-fit-row') === 'fit-' + v.b + '-' + v.m);
      });
    }

    $$('[data-aw-finder]').forEach(function (f) { if (f._awPrefill) f._awPrefill(v); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-aw-garage-clear]')) {
      e.preventDefault(); setGarage(null); toast('Vehículo quitado', 'Ahora ves todo el catálogo');
    }
    if (e.target.closest('[data-aw-garage-clear-soft]')) { setGarage(null); }
  });

  /* ── Buscador Marca › Modelo › Año ──────────────────────── */
  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = '';
    sel.add(new Option(placeholder, ''));
    items.forEach(function (it) { sel.add(new Option(it[1], it[0])); });
  }
  function initFinder(form) {
    var sb = $('[data-aw-vf="brand"]', form), sm = $('[data-aw-vf="model"]', form),
        sy = $('[data-aw-vf="year"]', form), go = $('[data-aw-vf="go"]', form);
    if (!sb) return;
    var abc = function (a, z) { return a[1].localeCompare(z[1], 'es', { sensitivity: 'base', numeric: true }); };
    var brands = Object.keys(VD).map(function (k) { return [k, VD[k].n]; }).sort(abc);
    fillSelect(sb, brands, 'Elige la marca');

    function loadModels(b) {
      var ms = (VD[b] && VD[b].m) || {};
      var items = Object.keys(ms).map(function (k) { return [k, ms[k][0]]; }).sort(abc);
      fillSelect(sm, items, items.length ? 'Elige el modelo' : 'Sin modelos');
      sm.disabled = !b || !items.length;
      fillSelect(sy, [], 'Todos los años'); sy.disabled = true;
    }
    function loadYears(b, m) {
      var mi = modelInfo(b, m);
      var ys = [];
      if (mi) { for (var y = mi.to; y >= mi.from; y--) ys.push([String(y), String(y)]); }
      fillSelect(sy, mi && mi.g.length ? [] : ys, 'Todos los años');
      if (mi && mi.g.length) {
        // años agrupados por generación: "Accent RB (2011-2020)" › 2020, 2019…
        var grupos = [], porGen = {};
        ys.forEach(function (it) {
          var g = genFor(b, m, it[0]);
          var key = g ? genLabel(g) : mi.name;
          if (!porGen[key]) { porGen[key] = document.createElement('optgroup'); porGen[key].label = key; grupos.push(porGen[key]); }
          porGen[key].appendChild(new Option(it[1], it[0]));
        });
        grupos.forEach(function (og) { sy.appendChild(og); });
      }
      sy.disabled = !ys.length;
    }
    function sync() { go.disabled = !(sb.value && sm.value); }

    sb.addEventListener('change', function () { loadModels(sb.value); sync(); if (sb.value) sm.focus(); });
    sm.addEventListener('change', function () { loadYears(sb.value, sm.value); sync(); if (sm.value) sy.focus(); });
    sy.addEventListener('change', sync);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!sb.value) { sb.focus(); return; }
      var v = { b: sb.value, m: sm.value || '', y: sy.value || '' };
      setGarage(v);
      // modelo sin productos publicados: Shopify ignora una etiqueta que no existe y mostraría
      // todo el catálogo, así que en vez de navegar ofrecemos cotizar por WhatsApp
      var mi0 = v.m ? modelInfo(v.b, v.m) : null;
      var sinAnio = mi0 && mi0.n && v.y && mi0.ys && mi0.ys.indexOf(+v.y) === -1;
      if (sinAnio) {
        var h2 = $('[data-aw-vf="hint"]', form), nom2 = vehicleName(v);
        if (h2) {
          h2.innerHTML = ''; h2.classList.add('is-empty');
          h2.appendChild(document.createTextNode('No tenemos repuestos publicados para ' + nom2 + '. '));
          var a1 = document.createElement('a'); a1.className = 'aw-linkbtn';
          a1.href = vehicleUrl({ b: v.b, m: v.m, y: '' }, form.getAttribute('data-scope') || '');
          a1.textContent = 'Ver todos los ' + mi0.name; h2.appendChild(a1);
          h2.appendChild(document.createTextNode(' o '));
          var a2 = document.createElement('a'); a2.className = 'aw-linkbtn'; a2.target = '_blank'; a2.rel = 'noopener';
          a2.href = waUrl('Hola Autowelt, busco repuestos para ' + nom2 + '. ¿Me pueden cotizar?');
          a2.textContent = 'cotizar por WhatsApp'; h2.appendChild(a2);
        }
        return;
      }
      if (mi0 && !mi0.n) {
        var hint = $('[data-aw-vf="hint"]', form), nombre = vehicleName(v);
        if (hint) {
          hint.innerHTML = '';
          hint.classList.add('is-empty');
          hint.appendChild(document.createTextNode('Aún no tenemos repuestos publicados para ' + nombre + '. Te lo conseguimos: '));
          var a = document.createElement('a');
          a.href = waUrl('Hola Autowelt, busco repuestos para ' + nombre + '. ¿Me pueden cotizar?');
          a.target = '_blank'; a.rel = 'noopener'; a.className = 'aw-linkbtn';
          a.textContent = 'cotizar por WhatsApp';
          hint.appendChild(a);
        }
        return;
      }
      var scope = form.getAttribute('data-scope') || '';
      window.location.href = vehicleUrl(v, scope);
    });
    // marca sola: permitir ir a la página de la marca
    sb.addEventListener('change', function () { if (sb.value && !sm.options.length) go.disabled = false; });

    form._awPrefill = function (v) {
      if (!v || !v.b || !VD[v.b]) return;
      if (sb.value === v.b && sm.value === (v.m || '') && sy.value === (v.y || '')) return;
      sb.value = v.b; loadModels(v.b);
      if (v.m && VD[v.b].m[v.m]) { sm.value = v.m; loadYears(v.b, v.m); if (v.y) sy.value = v.y; }
      sync();
    };
    form._awPrefill(getGarage());
  }

  /* ── Colección: orden, filtros, chips ───────────────────── */
  function initCollection() {
    $$('[data-aw-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
    var ff = $('[data-aw-filter-form]');
    if (ff) {
      ff.addEventListener('change', function (e) {
        if (!e.target.matches('[data-aw-autosubmit]')) return;
        submitFilters(ff);
      });
      ff.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(ff); });
      $$('[data-aw-filter-search]', ff).forEach(function (inp) {
        inp.addEventListener('input', function () {
          var q = norm(inp.value);
          $$('.aw-check', inp.parentNode).forEach(function (l) { l.hidden = q && norm(l.textContent).indexOf(q) === -1; });
        });
      });
    }

    // Chips de modelos (página de una marca)
    $$('[data-aw-model-chips]').forEach(function (box) {
      var b = box.getAttribute('data-aw-model-chips'), scope = box.getAttribute('data-scope');
      var ms = (VD[b] && VD[b].m) || {};
      Object.keys(ms).filter(function (k) { return ms[k][3]; }).forEach(function (k) {   // solo modelos con productos
        var a = document.createElement('a');
        a.className = 'aw-catchip'; a.textContent = ms[k][0];
        a.href = vehicleUrl({ b: b, m: k }, scope);
        
        box.appendChild(a);
      });
    });
    // Chips de años (página de un modelo sin año)
    $$('[data-aw-year-chips]').forEach(function (box) {
      var v = parseTag(box.getAttribute('data-aw-year-chips')), scope = box.getAttribute('data-scope');
      var mi = v && modelInfo(v.b, v.m); if (!mi) { box.hidden = true; return; }
      for (var y = mi.to; y >= mi.from; y--) {
        (function (yy) {
          var a = document.createElement('a');
          a.className = 'aw-catchip'; a.textContent = yy;
          a.href = vehicleUrl({ b: v.b, m: v.m, y: String(yy) }, scope);
          
          box.appendChild(a);
        })(y);
      }
    });

    // Al entrar a la página de un vehículo, recordarlo
    if (CFG.currentVehicleTag) {
      var cv = parseTag(CFG.currentVehicleTag), g = getGarage();
      var sameModel = g && cv && g.b === cv.b && g.m === cv.m;
      /* AW: ya no se recuerda el vehículo solo por visitar la página */
    }

    // Sin etiquetas cargadas todavía → buscar por texto (modo automático)
    var empty = $('[data-aw-vehicle-empty]');
    if (empty && empty.getAttribute('data-all') === '1' && CFG.mode !== 'tags') {
      var etag = empty.getAttribute('data-tag'), t = parseTag(etag);
      var hasSub = (CFG.currentTags || []).some(function (x) { return x.indexOf('sub-') === 0; });
      if (t && t.m && t.y && !hasSub) {
        // sin resultados para ese año → probar el modelo completo
        window.location.replace((R.all || '/collections/all') + '/fit-' + t.b + '-' + t.m + '?aw_ny=' + t.y);
      } else if (t && t.m && !hasSub) {
        window.location.replace(fallbackSearchUrl(etag));
      }
    }
    var ny = new URL(window.location.href).searchParams.get('aw_ny');
    var nyBox = $('[data-aw-noyear]');
    if (ny && nyBox) { nyBox.hidden = false; var s = $('[data-aw-noyear-y]', nyBox); if (s) s.textContent = ny; }
  }
  function submitFilters(form) {
    var fd = new FormData(form), u = new URL(form.action, window.location.origin);
    fd.forEach(function (val, key) { if (val !== '') u.searchParams.append(key, val); });
    window.location.href = u.pathname + (u.search || '');
  }

  /* ── Búsqueda: limpieza de la consulta ──────────────────── */
  var BRAND_WORDS = {};
  Object.keys(VD).forEach(function (k) { BRAND_WORDS[norm(VD[k].n)] = k; BRAND_WORDS[k] = k; });
  BRAND_WORDS['ssang yong'] = 'ssangyong'; BRAND_WORDS['great wall'] = 'greatwall'; BRAND_WORDS['chevy'] = 'chevrolet';
  var STOP = { de: 1, la: 1, el: 1, los: 1, las: 1, para: 1, con: 1, mi: 1, un: 1, una: 1, y: 1, auto: 1, repuesto: 1, repuestos: 1 };
  var SYN = {
    delantera: 'del', delantero: 'del', delanteras: 'del', delanteros: 'del',
    trasera: 'tras', trasero: 'tras', traseras: 'tras', traseros: 'tras',
    izquierda: 'lh', izquierdo: 'lh', derecha: 'rh', derecho: 'rh',
    pastilla: 'pastillas', amortiguadores: 'amortiguador', bieletas: 'bieleta', rotulas: 'rotula',
    bandejas: 'bandeja', frenos: 'freno', filtros: 'filtro', bujias: 'bujia', discos: 'disco',
    sensores: 'sensor', mangueras: 'manguera', correas: 'correa', faroles: 'farol', focos: 'farol',
    espejos: 'espejo', retenes: 'reten', homocineticas: 'homocinetica', axiales: 'axial',
    terminal: 'extremo', terminales: 'extremo', cazoletas: 'cazoleta', termostatos: 'termostato',
    radiadores: 'radiador', inyectores: 'inyector', bobinas: 'bobina', soportes: 'soporte',
    mazas: 'maza', rodamientos: 'rodamiento', empaquetaduras: 'empaquetadura', junta: 'empaquetadura',
    gasolina: 'bencina', embragues: 'embrague', valvulas: 'valvula', metales: 'metal'
  };
  // índice de modelos para detectar "tucson", "tiggo 2", etc.
  var MODEL_IDX = [];
  Object.keys(VD).forEach(function (b) {
    Object.keys(VD[b].m || {}).forEach(function (m) {
      var r = VD[b].m[m];
      // nombre, alias del ERP y sinónimos (Avante → Elantra, Grand Starex → H-1, Tucson TL → Tucson…)
      [r[0], r[4]].concat(r[5] || []).forEach(function (s) { if (s) MODEL_IDX.push({ b: b, m: m, s: norm(s).replace(/-/g, ' ') }); });
    });
  });
  MODEL_IDX.sort(function (a, z) { return z.s.length - a.s.length; });

  function collapseCodes(s) { return String(s || '').replace(/[0-9A-Za-z]+(?:[-.][0-9A-Za-z]+)+/g, function (t) { if (/^[A-Za-z]{2,3}-[A-Za-z]{2,4}-\d{3,5}$/.test(t)) return t; var c = t.replace(/[-.]/g, ''); return (c.length >= 7 && (c.match(/\d/g) || []).length >= 4) ? c : t; }); } document.addEventListener('submit', function (e) { var f = e.target; if (f && f.classList && f.classList.contains('aw-oemform')) { var i = f.querySelector('[name="q"]'); if (i) i.value = collapseCodes(i.value); } }, true); function analyzeQuery(raw) { raw = collapseCodes(raw);
    var q = ' ' + norm(raw).replace(/-/g, ' ') + ' ';
    var out = { brand: '', model: '', year: '', rest: '' };
    var ym = q.match(/\s(19[89]\d|20[0-4]\d)\s/);
    if (ym) { out.year = ym[1]; q = q.replace(ym[0], ' '); }
    Object.keys(BRAND_WORDS).sort(function (a, z) { return z.length - a.length; }).forEach(function (w) {
      var re = new RegExp('\\s' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s');
      if (re.test(q)) { if (!out.brand) out.brand = BRAND_WORDS[w]; q = q.replace(re, ' '); }
    });
    for (var i = 0; i < MODEL_IDX.length; i++) {
      var it = MODEL_IDX[i];
      if (out.brand && it.b !== out.brand) continue;
      if (it.s.length < 2) continue;
      var re2 = new RegExp('\\s' + it.s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/ /g, '\\s+') + '\\s');
      if (re2.test(q)) { out.brand = it.b; out.model = it.m; out.modelText = it.s; q = q.replace(re2, ' '); break; }
    }
    out.rest = q.trim().split(' ').filter(function (w) { return w && !STOP[w]; })
      .map(function (w) { return SYN[w] || w; }).join(' ');
    return out;
  }

  function initSearchForms() {
    $$('[data-aw-search-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var inp = form.querySelector('input[name="q"]'); if (!inp || !inp.value.trim()) return;
        var a = analyzeQuery(inp.value);
        if (a.brand && a.model) {
          var v = { b: a.brand, m: a.model, y: (a.year && modelInfo(a.brand, a.model)) ? a.year : '' };
          setGarage(v);
          if (!a.rest) { e.preventDefault(); window.location.href = vehicleUrl(v); return; }
          // pieza + modelo con etiquetas → colección exacta (vehículo + subcategoría)
          var sub = useTags() ? subFor(a.rest) : null;
          if (sub) { e.preventDefault(); window.location.href = vehicleUrl(v, null, sub); return; }
          // si no, buscar texto "pieza modelo" (así están escritos los títulos)
          var mi = modelInfo(a.brand, a.model);
          inp.value = (a.rest + ' ' + (mi ? mi.q : a.modelText)).trim();
          return;
        }
        if (a.brand && !a.rest) { e.preventDefault(); window.location.href = vehicleUrl({ b: a.brand }); return; }
        if (a.rest && (a.brand || a.year)) inp.value = a.rest;
        else if (a.rest) inp.value = a.rest;
      });
    });

    // aviso en búsqueda cuando venimos del buscador por vehículo en modo texto
    var u = new URL(window.location.href), vt = u.searchParams.get('aw_v');
    if (vt) {
      var v = parseTag(vt); if (v && v.m) setGarage(v);
      var n = $('[data-aw-fallback-notice]');
      if (n) { n.hidden = false; var nm = $('[data-aw-fallback-name]', n); if (nm) nm.textContent = vehicleName(v); }
    }
  }

  /* ── Búsqueda predictiva ────────────────────────────────── */
  var sugBox, sugInput, sugReq = 0;
  function hideSuggest() { if (sugBox) { sugBox.hidden = true; if (sugInput) sugInput.setAttribute('aria-expanded', 'false'); } }
  function initPredictive() {
    sugInput = $('[data-aw-psearch-input]'); sugBox = $('[data-aw-psearch-results]');
    if (!sugInput || !sugBox) return;
    var run = debounce(function () {
      var raw = sugInput.value.trim();
      if (raw.length < 2) { hideSuggest(); return; }
      var a = analyzeQuery(raw);
      var q = a.model ? ((a.rest + ' ' + (modelInfo(a.brand, a.model) || {}).q).trim()) : (a.rest || raw);
      var my = ++sugReq;
      var url = (R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,tag,vendor';
      fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        if (my !== sugReq) return;
        renderSuggest(raw, a, (d.resources && d.resources.results) || {});
      }).catch(function () { hideSuggest(); });
    }, 220);
    sugInput.addEventListener('input', run);
    sugInput.addEventListener('focus', function () { if (sugBox.innerHTML && sugInput.value.trim().length > 1) { sugBox.hidden = false; } });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-aw-psearch]')) hideSuggest(); });
    sugInput.addEventListener('keydown', function (e) {
      var items = $$('[data-sug]', sugBox); if (!items.length || sugBox.hidden) return;
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
    });
    sugBox.addEventListener('keydown', function (e) {
      var items = $$('[data-sug]', sugBox), i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (items[i + 1]) items[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) sugInput.focus(); else items[i - 1].focus(); }
    });
  }
  function renderSuggest(raw, a, res) {
    var html = '';
    if (a.brand && a.model) {
      var v = { b: a.brand, m: a.model, y: a.year && modelInfo(a.brand, a.model) ? a.year : '' };
      var sb = useTags() && a.rest ? subFor(a.rest) : null;
      if (sb) html += '<a class="aw-sug__veh" data-sug href="' + esc(vehicleUrl(v, null, sb)) + '">' +
        '<span class="aw-sug__vicon">🔧</span><span><strong>' + esc(sb.name) + '</strong> para <strong>' + esc(vehicleName(v)) + '</strong></span></a>';
      html += '<a class="aw-sug__veh aw-sug__veh--2" data-sug href="' + esc(vehicleUrl(v)) + '">' +
        '<span class="aw-sug__vicon">🚗</span><span>Todos los repuestos para <strong>' + esc(vehicleName(v)) + '</strong></span></a>';
    }
    var prods = res.products || [];
    if (prods.length) {
      html += '<div class="aw-sug__label">Productos</div>';
      prods.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = p.price != null ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
        html += '<a class="aw-sug__item" data-sug href="' + esc(p.url) + '">' +
          '<span class="aw-sug__img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
          '<span class="aw-sug__txt"><span class="aw-sug__title">' + esc(p.title) + '</span>' +
          '<span class="aw-sug__meta">' + esc(p.vendor || '') + (p.available === false ? ' · <em>Agotado</em>' : '') + '</span></span>' +
          '<span class="aw-sug__price">' + esc(price) + '</span></a>';
      });
    }
    var cols = res.collections || [];
    if (cols.length) {
      html += '<div class="aw-sug__label">Categorías</div><div class="aw-sug__cols">';
      cols.forEach(function (c) { html += '<a data-sug href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
      html += '</div>';
    }
    if (!prods.length && !cols.length && !(a.brand && a.model)) {
      html += '<div class="aw-sug__none">Sin coincidencias en la tienda online.<br>' +
        '<a href="' + esc(waUrl('Hola Autowelt, busco: ' + raw)) + '" target="_blank" rel="noopener">Pregúntanos por WhatsApp</a> · prueba con el código OEM</div>';
    } else {
      html += '<a class="aw-sug__all" data-sug href="' + esc((R.search || '/search') + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(raw)) + '">Ver todos los resultados para “' + esc(raw) + '” →</a>';
    }
    sugBox.innerHTML = html;
    sugBox.hidden = false;
    sugInput.setAttribute('aria-expanded', 'true');
  }

  /* ── Carrito AJAX ───────────────────────────────────────── */
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function addToCart(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return cartRequest((R.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
      .then(function (res) {
        var item = res.items ? res.items[0] : res;
        toast('Agregado al carrito', item && item.product_title ? item.product_title : '');
        return refreshCart().then(function () { open('cart'); });
      })
      .catch(function (err) {
        toast('No se pudo agregar', (err && (err.description || err.message)) || 'Intenta de nuevo o escríbenos por WhatsApp', 'warn');
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
  function refreshCart() {
    return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }
  function renderCart(cart) {
    $$('[data-aw-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    $$('[data-aw-cart-count-text]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    var body = $('[data-aw-cart-items]'), foot = $('[data-aw-cart-foot]');
    if (body) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="aw-drawer__empty"><p>Tu carrito está vacío</p><a href="' + esc(R.all || '/collections/all') + '" class="aw-btn aw-btn--primary aw-btn--sm">Ver catálogo</a></div>';
      } else {
        body.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          return '<div class="aw-ci" data-line="' + (i + 1) + '">' +
            '<a class="aw-ci__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
            '<div class="aw-ci__info"><a class="aw-ci__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title && !it.product_has_only_default_variant ? '<span class="aw-ci__sku">' + esc(it.variant_title) + '</span>' : '') +
            (it.sku ? '<span class="aw-ci__sku">SKU ' + esc(it.sku) + '</span>' : '') +
            '<span class="aw-ci__price">' + formatMoney(it.final_line_price) + '</span></div>' +
            '<div class="aw-ci__qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Restar">−</button>' +
            '<span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Sumar">+</button></div>' +
            '<button type="button" class="aw-ci__remove" data-qty="0" aria-label="Quitar">×</button></div>';
        }).join('');
      }
    }
    if (foot) foot.hidden = !cart.item_count;
    $$('[data-aw-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    paintShipping(cart.total_price);
    // carrito por WhatsApp
    var lines = (cart.items || []).map(function (it) { return '• ' + it.quantity + ' × ' + it.product_title + (it.sku ? ' (SKU ' + it.sku + ')' : ''); });
    var v = getGarage();
    var msg = 'Hola Autowelt, quiero comprar:\n' + lines.join('\n') + '\nTotal: ' + formatMoney(cart.total_price) + (v ? '\nVehículo: ' + vehicleName(v) : '');
    $$('[data-aw-cart-wa]').forEach(function (a) { a.href = waUrl(msg); });
  }
  function paintShipping(total) {
    var th = Number(CFG.freeShipping || 0);
    $$('[data-aw-ship]').forEach(function (el) {
      if (!th) { el.hidden = true; return; }
      var pct = Math.min(100, Math.round(total / th * 100));
      el.innerHTML = (total >= th
        ? '<span>🎉 <strong>¡Tienes envío gratis!</strong> ' + esc(CFG.freeShippingRegion || '') + '</span>'
        : '<span>Te faltan <strong>' + formatMoney(th - total) + '</strong> para envío gratis ' + esc(CFG.freeShippingRegion ? 'en ' + CFG.freeShippingRegion : '') + '</span>') +
        '<div class="aw-ship__bar"><i style="width:' + pct + '%"></i></div>';
    });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-aw-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-aw-add'), 1, add); return; }
    var q = e.target.closest('[data-aw-cart-items] [data-qty]');
    if (q) {
      var line = q.closest('[data-line]').getAttribute('data-line');
      q.disabled = true;
      cartRequest((R.cartChange || '/cart/change') + '.js', { line: Number(line), quantity: Number(q.getAttribute('data-qty')) })
        .then(renderCart).catch(function (err) { toast('No se pudo actualizar', (err && err.description) || '', 'warn'); refreshCart(); });
    }
  });

  /* ── Ficha de producto ──────────────────────────────────── */
  function initProduct() {
    var pdp = $('[data-aw-pdp]'); if (!pdp) return;
    var form = $('[data-aw-product-form]', pdp);
    var mainImg = $('[data-aw-gallery-main] img', pdp);

    $$('[data-aw-thumb]', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.getAttribute('data-aw-thumb'); }
        $$('[data-aw-thumb]', pdp).forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
    $$('[data-aw-qty]', pdp).forEach(function (box) {
      var inp = $('input', box);
      $$('[data-aw-qty-step]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var max = Number(inp.max) || 999;
          inp.value = Math.max(1, Math.min(max, (Number(inp.value) || 1) + Number(b.getAttribute('data-aw-qty-step'))));
        });
      });
    });
    var vs = $('[data-aw-variant]', pdp);
    if (vs) vs.addEventListener('change', function () {
      var o = vs.options[vs.selectedIndex];
      $$('[data-aw-price]').forEach(function (el) { el.textContent = o.getAttribute('data-price'); });
      var sku = $('[data-aw-sku]', pdp); if (sku) sku.textContent = o.getAttribute('data-sku') || '';
      var u = new URL(window.location.href); u.searchParams.set('variant', vs.value); history.replaceState(null, '', u.toString());
    });

    function currentId() { var i = form && form.querySelector('[name="id"]'); return i ? i.value : null; }
    function currentQty() { var i = form && form.querySelector('[name="quantity"]'); return i ? i.value : 1; }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); addToCart(currentId(), currentQty(), $('[data-aw-add-form]', form));
    });
    var buy = $('[data-aw-buy-now]', pdp);
    if (buy) buy.addEventListener('click', function () {
      buy.disabled = true;
      cartRequest((R.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(currentId()), quantity: Number(currentQty()) }] })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { buy.disabled = false; toast('No se pudo continuar', (err && err.description) || '', 'warn'); });
    });

    // barra fija en celular
    var sticky = $('[data-aw-sticky]'), addBtn = $('[data-aw-add-form]', pdp);
    if (sticky && addBtn) {
      var tick = false;
      var check = function () { tick = false; sticky.hidden = addBtn.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
      check();
      $('[data-aw-sticky-add]', sticky).addEventListener('click', function (e) { addToCart(currentId(), currentQty(), e.currentTarget); });
    }

    // Equivalentes por código OEM (búsqueda predictiva)
    var eq = $('[data-aw-equiv]'), list = eq && $('[data-aw-equiv-list]', eq);
    var codes = (function () { try { return atob(pdp.getAttribute('data-oem') || ''); } catch (err) { return ''; } })().split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 3);
    if (eq && list && !list.children.length && codes.length) {
      var pid = String(pdp.getAttribute('data-product-id'));
      var seen = {}, found = [];
      Promise.all(codes.map(function (c) {
        return fetch((R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(c) +
          '&resources[type]=product&resources[limit]=8&resources[options][fields]=tag,variants.sku,title', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
          .catch(function () { return []; });
      })).then(function (all) {
        all.forEach(function (arr) { arr.forEach(function (p) { if (String(p.id) !== pid && !seen[p.id] && (p.title || '').trim().toLowerCase() !== ((document.querySelector('.aw-pdp__title') || {}).textContent || '').trim().toLowerCase()) { seen[p.id] = 1; found.push(p); } }); });
        if (!found.length) return;
        list.innerHTML = found.slice(0, 8).map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          return '<article class="aw-pc aw-pc--mini"><a class="aw-pc__img" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="aw-pc__body"><span class="aw-pc__brand">' + esc(p.vendor || '') + '</span>' +
            '<h3 class="aw-pc__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
            '<div class="aw-pc__foot"><span class="aw-pc__price">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span>' +
            (p.available === false ? '<span class="aw-stock aw-stock--out">Agotado</span>' : '') + '</div></div></article>';
        }).join('');
        eq.hidden = false;
      });
    }
  }

  function initRecos() {
    var box = $('[data-aw-recos]'); if (!box || box.children.length) return;
    var load = function () {
      fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-aw-recos]');
        if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; var pdpEl = $('[data-aw-pdp]'); var pf = ((pdpEl && pdpEl.getAttribute('data-fit')) || '').split(/\s+/).filter(function (t) { return t.split('-').length > 2; }); $$('[data-aw-card]', box).forEach(function (c) { var cf = (c.getAttribute('data-fit') || '').split(/\s+/); if (!pf.length || !pf.some(function (t) { return cf.indexOf(t) > -1; })) c.remove(); }); if (!$('[data-aw-card]', box)) { box.innerHTML = ''; return; } paintGarage(); bindFinders(box); }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(box);
    } else load();
  }

  /* ── Pestañas del buscador de portada ───────────────────── */
  function initTabs() {
    $$('[data-aw-tabs]').forEach(function (root) {
      var tabs = $$('[data-aw-tab]', root);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var k = t.getAttribute('data-aw-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
          $$('[data-aw-tabpanel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-aw-tabpanel') !== k; });
        });
      });
    });
  }

  /* ── Patente ────────────────────────────────────────────── */
  function matchVehicle(marca, modelo) {
    var nb = norm(marca).replace(/[\s-]/g, '');
    var b = Object.keys(VD).filter(function (k) { return k === nb || norm(VD[k].n).replace(/[\s-]/g, '') === nb; })[0];
    if (!b) return null;
    var nm = ' ' + norm(modelo).replace(/-/g, ' ') + ' ';
    var best = null;
    Object.keys(VD[b].m).forEach(function (m) {
      var r = VD[b].m[m];
      [r[0], r[4]].forEach(function (s) {
        var ns = norm(s).replace(/-/g, ' ');
        if (ns && nm.indexOf(' ' + ns + ' ') !== -1 && (!best || ns.length > best.len)) best = { m: m, len: ns.length };
      });
    });
    return { b: b, m: best ? best.m : '' };
  }
  function initPlate() {
    $$('[data-aw-plate]').forEach(function (form) {
      var inp = $('[data-aw-plate-input]', form), out = $('[data-aw-plate-result]', form);
      inp.addEventListener('input', function () { inp.value = inp.value.replace(/[^a-z0-9]/gi, '').toUpperCase().slice(0, 6); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var plate = inp.value;
        if (plate.length < 5) { toast('Revisa la patente', 'Debe tener 6 caracteres, ej: ABCD12', 'warn'); inp.focus(); return; }
        if (!CFG.plateProxy) { window.open(waUrl('Hola Autowelt, mi patente es ' + plate + '. ¿Me ayudan a encontrar un repuesto?'), '_blank'); return; }
        out.hidden = false; out.className = 'aw-plateform__result'; out.textContent = 'Consultando patente…';
        var url = CFG.plateProxy + (CFG.plateProxy.indexOf('?') > -1 ? '&' : '?') + 'plate=' + encodeURIComponent(plate);
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          var data = d && (d.data || d);
          var marca = data && (data.marca || data.brand || data.make), modelo = data && (data.modelo || data.model),
              anio = data && String(data.ano || data.anio || data.year || '');
          if (!marca) throw new Error('sin datos');
          var v = matchVehicle(marca, modelo || '');
          var label = [marca, modelo, anio].filter(Boolean).join(' ');
          if (v && v.m) {
            var mi = modelInfo(v.b, v.m);
            v.y = mi && Number(anio) >= mi.from && Number(anio) <= mi.to ? anio : '';
            setGarage(v);
            out.className = 'aw-plateform__result is-ok';
            out.innerHTML = '<strong>' + esc(label) + '</strong><a class="aw-btn aw-btn--primary aw-btn--sm" href="' + esc(vehicleUrl(v)) + '">Ver repuestos que calzan →</a>';
          } else {
            out.className = 'aw-plateform__result is-warn';
            out.innerHTML = '<strong>' + esc(label) + '</strong><span>Este modelo aún no está en el buscador.</span><a class="aw-btn aw-btn--wa aw-btn--sm" target="_blank" rel="noopener" href="' + esc(waUrl('Hola Autowelt, busco repuestos para ' + label + ' (patente ' + plate + ')')) + '">Consultar por WhatsApp</a>';
          }
        }).catch(function () {
          out.className = 'aw-plateform__result is-warn';
          out.innerHTML = '<span>No pudimos identificar la patente.</span><a class="aw-btn aw-btn--wa aw-btn--sm" target="_blank" rel="noopener" href="' + esc(waUrl('Hola Autowelt, mi patente es ' + plate + '. ¿Me ayudan con un repuesto?')) + '">Enviar por WhatsApp</a>';
        });
      });
    });
  }

  /* ── Cotizador ──────────────────────────────────────────── */
  function initCotizador() {
    var root = $('[data-aw-cot]'); if (!root) return;
    var form = $('[data-aw-cot-form]', root); if (!form || !$('[data-aw-cot-panel]', root)) return;
    var items = [];
    var nameEl = $('[data-aw-cot-name]', root), qtyEl = $('[data-aw-cot-qty]', root), oemEl = $('[data-aw-cot-oem]', root);
    var brandSel = $('[data-aw-cot-brand]', root), modelsDl = $('[data-aw-cot-models]', root);

    Object.keys(VD).sort(function (a, z) { return VD[a].n.localeCompare(VD[z].n, 'es', { sensitivity: 'base' }); })
      .forEach(function (k) { brandSel.add(new Option(VD[k].n, VD[k].n)); });
    brandSel.add(new Option('Otra', 'Otra'));
    brandSel.addEventListener('change', function () {
      modelsDl.innerHTML = '';
      var k = Object.keys(VD).filter(function (x) { return VD[x].n === brandSel.value; })[0];
      if (k) Object.keys(VD[k].m).forEach(function (m) { var o = document.createElement('option'); o.value = VD[k].m[m][0]; modelsDl.appendChild(o); });
    });
    var g = getGarage();
    if (g && VD[g.b]) {
      brandSel.value = VD[g.b].n; brandSel.dispatchEvent(new Event('change'));
      var mi = g.m && modelInfo(g.b, g.m);
      if (mi) $('#aw-cot-model').value = mi.name;
      if (g.y) $('#aw-cot-year').value = g.y;
    }

    function render() {
      var list = $('[data-aw-cot-items]', root), empty = $('[data-aw-cot-empty]', root);
      empty.style.display = items.length ? 'none' : 'block';
      list.innerHTML = items.map(function (it, i) {
        return '<div class="aw-cot-item"><span class="aw-cot-item__n">' + (i + 1) + '</span><span class="aw-cot-item__name">' + esc(it.name) +
          (it.oem ? ' <span class="aw-cot-item__oem">[' + esc(it.oem) + ']</span>' : '') + '</span><span class="aw-cot-item__qty">×' + it.qty +
          '</span><button type="button" class="aw-cot-item__del" data-del="' + i + '" aria-label="Quitar">×</button></div>';
      }).join('');
    }
    function addItem() {
      var n = nameEl.value.trim(); if (!n) { nameEl.focus(); return false; }
      items.push({ name: n, qty: Math.max(1, parseInt(qtyEl.value, 10) || 1), oem: oemEl.value.trim() });
      nameEl.value = ''; oemEl.value = ''; qtyEl.value = 1; nameEl.focus(); render(); return true;
    }
    $('[data-aw-cot-add]', root).addEventListener('click', addItem);
    nameEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addItem(); } });
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-del]'); if (d) { items.splice(Number(d.getAttribute('data-del')), 1); render(); }
      var go = e.target.closest('[data-aw-cot-go]'); if (go) step(Number(go.getAttribute('data-aw-cot-go')));
    });
    function step(n) {
      if (n > 1 && !items.length) { if (!addItem()) { toast('Falta la pieza', 'Agrega al menos un repuesto', 'warn'); return; } }
      $$('[data-aw-cot-panel]', root).forEach(function (p) { p.classList.toggle('is-active', Number(p.getAttribute('data-aw-cot-panel')) === n); });
      $$('[data-aw-cot-tab]', root).forEach(function (t) {
        var i = Number(t.getAttribute('data-aw-cot-tab'));
        t.classList.toggle('is-active', i === n); t.classList.toggle('is-done', i < n);
      });
      if (n === 3) $('[data-aw-cot-summary]', root).innerHTML = items.map(function (it) {
        return '<div class="aw-cot-summary-row"><span class="aw-cot-summary-row__k">' + esc(it.name) + (it.oem ? ' [' + esc(it.oem) + ']' : '') + '</span><span class="aw-cot-summary-row__v">× ' + it.qty + '</span></div>';
      }).join('');
    }
    function bodyText() {
      var veh = [brandSel.value, $('#aw-cot-model').value, $('#aw-cot-year').value, $('#aw-cot-motor').value].filter(Boolean).join(' ');
      var plate = $('#aw-cot-plate').value;
      return 'COTIZACIÓN WEB\n\nPiezas:\n' + items.map(function (it, i) {
        return (i + 1) + '. ' + it.name + ' × ' + it.qty + (it.oem ? ' (OEM ' + it.oem + ')' : '');
      }).join('\n') + '\n\nVehículo: ' + (veh || 'no indicado') + (plate ? '\nPatente: ' + plate.toUpperCase() : '') +
        '\nTipo de cliente: ' + $('#aw-cot-type').value;
    }
    $('[data-aw-cot-wa]', root).addEventListener('click', function () {
      if (!items.length) { step(1); return; }
      var nm = $('#aw-cot-cname').value;
      window.open(waUrl(bodyText() + (nm ? '\nNombre: ' + nm : '')), '_blank');
    });
    form.addEventListener('submit', function (e) {
      if (!items.length) { e.preventDefault(); step(1); return; }
      $('[data-aw-cot-body]', root).value = bodyText();
    });
  }

  /* ── Rotador de anuncios (móvil) ────────────────────────── */
  function initRotator() {
    var r = $('[data-aw-rotator]'); if (!r) return;
    var msgs = $$('.aw-annc__msg', r); if (msgs.length < 2) return;
    var i = 0; msgs.forEach(function (m, k) { m.classList.toggle('is-on', k === 0); });
    setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 5000);
  }

  function bindFinders(ctx) { $$('[data-aw-finder]', ctx).forEach(function (f) { if (!f._awInit) { f._awInit = true; initFinder(f); } }); }

  /* ── Inicio ─────────────────────────────────────────────── */
  function init() {
    bindFinders(document);
    initCollection();
    initSearchForms();
    initPredictive();
    initProduct();
    initRecos();
    initTabs();
    initPlate();
    initCotizador();
    initRotator();
    paintGarage();
    var badge = $('[data-aw-cart-count]');
    if (badge && Number(badge.textContent) > 0) refreshCart();
    else paintShipping(0);
    if (window.location.hash === '#cart') open('cart');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.AW.api = { subFor: subFor, useTags: useTags, open: open, close: close, addToCart: addToCart, getGarage: getGarage, setGarage: setGarage, analyzeQuery: analyzeQuery, vehicleUrl: vehicleUrl };
})();
